/**
 * PolicyGateBadge
 * 
 * Shows when a decision trace was flagged by policy gating.
 * Displays "Policy approval required" badge with tooltip showing the reason.
 */

import React from 'react';
import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { ShieldAlert } from 'lucide-react';

export default function PolicyGateBadge({ trace }) {
  const policyGate = trace?.metadata?.policy_gate;
  
  if (!policyGate?.reason) {
    return null;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            className="inline-flex items-center gap-1.5 bg-amber-400/10 border-amber-400/30 text-amber-100 hover:bg-amber-400/15"
            data-testid="policy-gate-badge"
          >
            <ShieldAlert className="h-3 w-3" />
            Policy approval required
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <p className="text-sm">
            <strong>Policy gate:</strong> {policyGate.reason}
          </p>
          {policyGate.policy_key && (
            <p className="text-xs text-muted-foreground mt-1">
              Policy: {policyGate.policy_key}
            </p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
